import React from 'react';
import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import './LandlordStatsSection.scss';

const statsItems = [
  {
    title: 'landlord.landing.standard.stats.owners-trust.title',
    description: 'landlord.landing.standard.stats.owners-trust.description'
  },
  {
    title: 'landlord.landing.standard.stats.users-per-month.title',
    description: 'landlord.landing.standard.stats.users-per-month.description'
  },
  {
    title: 'landlord.landing.standard.stats.published-properties.title',
    description:
      'landlord.landing.standard.stats.published-properties.description'
  }
];

const StatsItem = ({ title, description }) => (
  <div className="landlord-stats-section__item">
    <h2 className="landlord-stats-section__title">{trans(title)}</h2>
    <p className="landlord-stats-section__description">{trans(description)}</p>
  </div>
);

StatsItem.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
};

const LandlordStatsSection = () => (
  <section className="landlord-stats-section">
    <div className="landlord-stats-section__wrapper">
      {statsItems.map(({ title, description }) => (
        <StatsItem key={title} title={title} description={description} />
      ))}
    </div>
  </section>
);

export default LandlordStatsSection;
